import Swiper from 'swiper';
import { breakpoints, measurements } from '../conf';

export default () => {
  // selectors and data
  const els = document.querySelectorAll('[data-range-swiper]');
  const breakpoint = window.matchMedia(`(min-width:${breakpoints.md}px)`);
  const swipers = [];

  const options = {
    slidesPerView: 'auto',
    spaceBetween: measurements.gutterWidth,
    scrollbar: {
      el: '[data-range-swiper-scrollbar]',
      hide: false,
    },
    navigation: {
      nextEl: '[data-range-swiper-next]',
      prevEl: '[data-range-swiper-prev]',
    },
  };

  // functions
  const enableSwipers = () => {
    if (els.length) {
      els.forEach((el) => {
        swipers.push(new Swiper(el, options));
      });
    }
  };

  const breakpointChecker = (swiper) => {
    if (breakpoint.matches === true) {
      while (swipers.length > 0) {
        if (swipers[0] !== undefined) swipers[0].destroy(true, true);
        swipers.shift();
      }
      return swiper;
    }
    return enableSwipers();
  };

  // init
  breakpointChecker();
  breakpoint.addListener(breakpointChecker);
};
